import { ColorOrCustom, dynamicStyling } from 'styles';

import { BaseLoaderProps } from './types';

interface AtomLoaderProps extends BaseLoaderProps {
  leftBladeColor?: ColorOrCustom;
  rightBladeColor?: ColorOrCustom;
  uniColor?: ColorOrCustom;
}

const blaseClass = 'atomic-blade';

export function AtomLoader({
  leftBladeColor,
  rightBladeColor,
  uniColor,
  inheritColor,
  size = 20,
}: AtomLoaderProps) {
  const defaultColor = inheritColor ? 'currentColor' : uniColor;

  return (
    <span
      {...dynamicStyling({
        size,

        className: 'rotate-45 rounded-full inline-block shrink-0',
      })}
    >
      <span
        {...dynamicStyling({
          color: defaultColor ?? leftBladeColor ?? 'primary',
          size,

          className: `${blaseClass} left-blade absolute top-0 left-0 rounded-full`,
        })}
      />

      <span
        {...dynamicStyling({
          color: defaultColor ?? rightBladeColor ?? 'primary',
          size,

          className: `${blaseClass} right-blade absolute top-0 left-0 rounded-full`,
        })}
      />

      <style
        dangerouslySetInnerHTML={{
          __html: `
            .${blaseClass} {
              animation: 1s atomSpin___ linear infinite;
            }

            .left-blade {
              transform: rotateX(70deg);
            }

            .right-blade {
              transform: rotateY(70deg);
              animation-delay: 0.4s;
            }

            @keyframes atomSpin___ {
              0%,
              100% {
                box-shadow: 0.2em 0px 0 0px currentcolor;
              }
              12% {
                box-shadow: 0.2em 0.2em 0 0 currentcolor;
              }
              25% {
                box-shadow: 0 0.2em 0 0px currentcolor;
              }
              37% {
                box-shadow: -0.2em 0.2em 0 0 currentcolor;
              }
              50% {
                box-shadow: -0.2em 0 0 0 currentcolor;
              }
              62% {
                box-shadow: -0.2em -0.2em 0 0 currentcolor;
              }
              75% {
                box-shadow: 0px -0.2em 0 0 currentcolor;
              }
              87% {
                box-shadow: 0.2em -0.2em 0 0 currentcolor;
              }
            }
        `,
        }}
      />
    </span>
  );
}
